import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationES from './locales/es/translation.json';

//translations
const resources = {
   es: {
    translation: translationES
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "es", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;